import { Language } from '../constants';

// Screen-reader labels, never visible text
const a11yEn = {
  gateImageAlt: 'Famagusta Gate',
  qrCodeTitle: 'QR code for famagustagate.com',
  euFundingAlt: 'Funded by the European Union',
  selectLanguage: 'Select language',
  closeMenu: 'Close menu',
  languageMenu: 'Language menu',
  footerNav: 'Site pages',
  contentLoaded: 'Content loaded',
};

export type A11yStrings = typeof a11yEn;

const a11y: Record<Language, A11yStrings> = {
  EN: a11yEn,
  EL: {
    gateImageAlt: 'Πύλη Αμμοχώστου',
    qrCodeTitle: 'Κωδικός QR για το famagustagate.com',
    euFundingAlt: 'Με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης',
    selectLanguage: 'Επιλογή γλώσσας',
    closeMenu: 'Κλείσιμο μενού',
    languageMenu: 'Μενού γλωσσών',
    footerNav: 'Σελίδες ιστότοπου',
    contentLoaded: 'Το περιεχόμενο φορτώθηκε',
  },
  TR: {
    gateImageAlt: 'Mağusa Kapısı',
    qrCodeTitle: 'famagustagate.com için QR kodu',
    euFundingAlt: 'Avrupa Birliği tarafından finanse edilmektedir',
    selectLanguage: 'Dil seçin',
    closeMenu: 'Menüyü kapat',
    languageMenu: 'Dil menüsü',
    footerNav: 'Site sayfaları',
    contentLoaded: 'İçerik yüklendi',
  },
};

export function useA11y(lang: Language): A11yStrings {
  return a11y[lang];
}
